import React from 'react';

import { EditorContent } from '@tiptap/react';
import { Content } from '@tiptap/core';

import { useTipTapEditor, type UseTipTapEditorProps } from '../../hooks/useTipTapEditor';

export type RichTextViewerProps = {
  content: Content;
} & Pick<UseTipTapEditorProps, 'size'>;

const RichTextViewer = ({ content, size }: RichTextViewerProps) => {
  const { editor } = useTipTapEditor({
    value: content,
    editable: false,
    size,
  });

  return <EditorContent editor={editor} />;
};

export { RichTextViewer };
